import { useCreateFlowSession } from "@/api/flow_sessions";
import { useCanvasHarnessDraft } from "@/hooks/useHarnessDraft";
import { emitCanvasOpenFloatingSession } from "@/pages/canvas/context/CanvasFloatingChatContext";
import { FLOW_SESSION_MODES } from "@cohesive/api-client";
import { useCallback } from "react";

export function useCanvasRailNewChat(canvasId: string, canEdit: boolean) {
  const createFlowSession = useCreateFlowSession();
  // The rail starts the chat before the user has typed, so the canvas's standing choice is the
  // only one there is to stamp — the same one its composers offer.
  const [harnessDraft] = useCanvasHarnessDraft(canvasId);

  const handleNewChat = useCallback(async () => {
    if (!canEdit || !canvasId || createFlowSession.isPending) return;
    const newSession = await createFlowSession.mutateAsync({
      mode: FLOW_SESSION_MODES.CANVAS_CHAT,
      class: "canvas",
      canvas_id: canvasId,
      harness: harnessDraft.harness,
      model: harnessDraft.model,
    });
    emitCanvasOpenFloatingSession({
      canvasId,
      flowSessionId: newSession.id,
    });
  }, [canEdit, canvasId, createFlowSession, harnessDraft]);

  return {
    handleNewChat,
    isCreatingChat: createFlowSession.isPending,
  };
}
